/**
 * Route path constants. Importing these instead of writing raw strings keeps
 * navigation links and Navigate redirects in sync when routes move.
 */

export const PATHS = {
  root:         '/',
  login:        '/login',
  unauthorized: '/unauthorized',
  app:          '/app',
  dashboard:    '/app/dashboard',
  taskDetail:   '/app/tasks/:taskId',
  taskCreate:   '/app/tasks/new',
  taskBulk:     '/app/tasks/bulk-new',
  roomBoard:    '/app/board',
  roomDetail:   '/app/rooms/:roomId',
  corrections:  '/app/corrections',
  anomalies:    '/app/anomalies',
  team:         '/app/team',
  feeRequests:  '/app/fee-requests',
  orgSettings:  '/app/settings',
  reports:      '/app/reports',
  bidTool:      '/app/bid-tool',
  abandonedBelongings: '/app/abandoned-belongings',
  leads:        '/app/leads',
} as const

export function taskDetailPath(taskId: string): string {
  return `/app/tasks/${taskId}`
}

export function roomDetailPath(roomId: string): string {
  return `/app/rooms/${roomId}`
}
